import { createContext, useContext } from 'react';

import AnnotatorConstants from '../modules/annotator/annotator.constants';

const { INSIPIENT_MARKS, MARK_TO_BOX_PERCENTAGE_OF_IMAGE } = AnnotatorConstants;

const defaultMinIncipientSize = MARK_TO_BOX_PERCENTAGE_OF_IMAGE.get(
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  INSIPIENT_MARKS.at(0).value,
);
const defaultMaxIncipientSize = MARK_TO_BOX_PERCENTAGE_OF_IMAGE.get(
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  INSIPIENT_MARKS.at(-1).value,
);

export const defaultIncipientThresholdRange = [
  defaultMinIncipientSize,
  defaultMaxIncipientSize,
];

export type UseIncipientReturn = {
  incipientThresholdRange: [number, number];
};

export const IncipientContext = createContext({});

export const useIncipient = () => useContext(IncipientContext);
